<template lang="pug">
#visualizar-pre-analise-credito
    BaseHeaderPreAnaliseCredito(
        :titulo='i18nStrings.titulo',
        :voltarPara='true',
        :exibeBotao='false',
        :rotaHome='goBackHomeDashboard || false'
        )
    .view-container-base-header
        .visualizar-pre-analise-credito__card
            .card-container.mb-3.px-4
                .visualizar-pre-analise-credito__card__status
                    div(:class='isPessoaFisica ? "grid-cpf" : "grid-cnpj"')
                        .text-left
                            div(v-if='isPessoaFisica')
                                span.font-bold {{ $t('mensagens.preAnaliseCredito.visualizar.container.nome') }}
                                    |
                                    span.font-weight-normal.ml-1(v-if='resultadoConsulta.nome')
                                        | {{ mxNormalisarNomes(resultadoConsulta.nome) }}
                                    span.font-weight-normal.ml-1(v-else-if='resultadoConsulta.bndes')
                                        span(v-if='resultadoConsulta.bndes.facets.nome')
                                            | {{ mxNormalisarNomes(resultadoConsulta.bndes.facets.nome.buckets[0].val) || mxNormalisarNomes(resultadoConsulta.bndes.response.docs[0].cliente) }}
                                        span.font-weight-normal.ml-1(v-else)
                                            | {{ $t('mensagens.preAnaliseCredito.visualizar.container.nomeNaoEncontrado') }}
                                    span.font-weight-normal.ml-1(v-else)
                                        | {{ $t('mensagens.preAnaliseCredito.visualizar.container.nomeNaoEncontrado') }}
                            div(v-else)
                                span.font-bold {{ $t('mensagens.preAnaliseCredito.visualizar.container.nome') }}
                                    |
                                    span.font-weight-normal.ml-1(v-if='resultadoConsulta.bndes')
                                        span(v-if='resultadoConsulta.bndes.facets.nome')
                                            | {{ mxNormalisarNomes(resultadoConsulta.bndes.facets.nome.buckets[0].val) || mxNormalisarNomes(resultadoConsulta.bndes.response.docs[0].cliente) }}
                                        span.font-weight-normal.ml-1(v-else)
                                            | {{ $t('mensagens.preAnaliseCredito.visualizar.container.nomeNaoEncontrado') }}
                                    span.font-weight-normal.ml-1(v-else)
                                        | {{ $t('mensagens.preAnaliseCredito.visualizar.container.nomeNaoEncontrado') }}
                                
                        .text-left
                            span.font-bold {{ $t('mensagens.preAnaliseCredito.visualizar.container.textoCpfCnpj') }}
                                |
                                span.font-weight-normal.ml-1
                                    | {{ numeralStringFormatToDocumento(resultadoConsulta.cpfCnpj) || numeralStringFormatToDocumento($route.params.cpfCnpj) }}
                        .text-left(v-if='isPessoaFisica')
                            span.font-bold {{ $t('mensagens.preAnaliseCredito.visualizar.container.dataNascimento') }}
                                |
                                span.font-weight-normal.ml-1
                                    | {{ resultadoConsulta.dataNascimento }}
                        .text-left(v-if='$route.params.historico')
                            span.font-bold {{ $t('mensagens.preAnaliseCredito.visualizar.container.dataConsulta') }}
                                |
                                span.font-weight-normal.ml-1
                                    | {{ $route.params.historico }}
                        div
                            .text-right
                                .ferramentas-opcoes--bloco--item(
                                    @click='abrirModalExportarDados'
                                )
                                    i.mdi.mdi-tray-arrow-down
                                    | {{ $t('mensagens.preAnaliseCredito.visualizar.container.exportarDados') }}
                        .text-right
                            .ferramentas-opcoes--bloco--item(
                                @click='marcarExportacaoAnaliseCreditoPdf'
                            )
                                i.mdi.mdi-check-underline
                                | {{ $t('mensagens.preAnaliseCredito.visualizar.container.marcarExportacao') }}
            el-alert.mb-3.px-4.warning-bndes(
                v-if='showWarningMessage(resultadoConsulta)',
                :title='getTitleWarningMessage(resultadoConsulta)',
                type='warning',
                :closable='false',
                show-icon
            )

            div(
                :class='!isCollapse ? "grid-display-pre-analise-credito-not-collapse" : " grid-display-pre-analise-credito-collapse"'
            )
                .grid-bloco1
                    span.arrow-menu-button(@click='changeCollapse')
                        i(
                            :class='!isCollapse ? "el el-icon-arrow-left" : "el el-icon-arrow-right"'
                        )
                    .card-container
                        el-menu.el-menu(
                            v-if='isPessoaFisica',
                            default-active='0',
                            :collapse='isCollapse',
                            @select='mudarViewAtual'
                        )
                            div(v-for='item in itemsMenuPF', :key='item.index')
                                el-menu-item(
                                    :index='item.index',
                                    :disabled='item.disabled'
                                )
                                    i(:class='item.icon')
                                    span(slot='title') {{ item.name }}
                                        i(
                                            :class='item.searchSucceeded ? "mdi mdi-check-circle-outline text-success ml-1" : "mdi mdi-alert-outline text-warning ml-1"'
                                        )
                        el-menu.el-menu(
                            v-else,
                            default-active='0',
                            :collapse='isCollapse',
                            @select='mudarViewAtual'
                        )
                            div(v-for='item in itemsMenuPJ', :key='item.index')
                                el-menu-item(
                                    :index='item.index',
                                    :disabled='item.disabled'
                                )
                                    i(:class='item.icon')
                                    span(slot='title') {{ item.name }}
                                        i(
                                            :class='item.searchSucceeded ? "mdi mdi-check-circle-outline text-success ml-1" : "mdi mdi-alert-outline text-warning ml-1"'
                                        )

                .grid-bloco2
                    .card-container(
                        v-if='isPessoaFisica',
                        style='min-height: 72vh; max-height: 72vh; overflow-y: auto'
                    )
                        TabelaDadosFinanceirosPf(
                            v-if='isPessoaFisica && viewAtual === "0"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.dadosFinanceiros',
                            icone-titulo-tabela='mdi mdi-cash'
                        )
                        TabelaDadosFiscaisTributariosPf(
                            v-if='isPessoaFisica && viewAtual === "1"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.dadosFiscaisTributarios',
                            icone-titulo-tabela='mdi mdi-gavel'
                        )
                        TabelaInfosProfissionaisPf(
                            v-if='isPessoaFisica && viewAtual === "2"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.infoProfissional',
                            icone-titulo-tabela='mdi mdi-handshake-outline'
                        )
                        TabelaInfosPublicasBndesPf(
                            v-if='isPessoaFisica && viewAtual === "3"',
                            :dados='resultadoConsulta.bndes || {}',
                            :titulo-tabela='stringsAdaptadas.infoPublicaBNDES',
                            icone-titulo-tabela='mdi mdi-cloud-search-outline'
                        )
                        TabelaPatrimonioPf(
                            v-if='isPessoaFisica && viewAtual === "4"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.patrimonio',
                            icone-titulo-tabela='mdi mdi-home-silo-outline'
                        )
                        TabelaPepPf(
                            v-if='isPessoaFisica && viewAtual === "5"',
                            :dados='resultadoConsulta.pessoaPoliticamenteExposta || {}',
                            :titulo-tabela='stringsAdaptadas.pessoaPoliticamenteExposta',
                            icone-titulo-tabela='mdi mdi-account-outline'
                        )
                        ProcessosJudiciaisTotalizadores(
                            v-if='isPessoaFisica && viewAtual === "6"',
                            :is-pessoa-fisica='true',
                            :is-pessoa-juridica='false',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.processosJudiciais',
                            icone-titulo-tabela='mdi mdi-folder-open-outline',
                        )
                        TabelaRelacionamentosPf(
                            v-if='isPessoaFisica && viewAtual === "7"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.relacionamentos',
                            icone-titulo-tabela='mdi mdi-account-group-outline'
                        )
                        TabelaSancoesRestricoesPf(
                            v-if='isPessoaFisica && viewAtual === "8"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.sancoesRestricoes',
                            icone-titulo-tabela='mdi mdi-file-document-outline'
                        )

                    .card-container(
                        v-else,
                        style='min-height: 72vh; max-height: 72vh; overflow-y: auto'
                    )
                        TabelaDadosFinanceirosPj(
                            v-if='!isPessoaFisica && viewAtual === "0"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.dadosFinanceiros',
                            icone-titulo-tabela='mdi mdi-cash'
                        )
                        TabelaDadosFiscaisPj(
                            v-if='!isPessoaFisica && viewAtual === "1"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.dadosFiscais',
                            icone-titulo-tabela='mdi mdi-gavel'
                        )
                        TabelaInfosPublicasBndesPj(
                            v-if='!isPessoaFisica && viewAtual === "2"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.infoPublicaBNDES',
                            icone-titulo-tabela='mdi mdi-cloud-search-outline'
                        )
                        TabelaPatrimonioPj(
                            v-if='!isPessoaFisica && viewAtual === "3"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.patrimonio',
                            icone-titulo-tabela='mdi mdi-home-silo-outline'
                        )
                        ProcessosJudiciaisTotalizadores(
                            v-if='!isPessoaFisica && viewAtual === "4"',
                            v-bind:is-pessoa-juridica='true',
                            v-bind:is-pessoa-fisica='false',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.processosJudiciais',
                            icone-titulo-tabela='mdi mdi-folder-open-outline',
                        )
                        TabelaRelacionamentosPj(
                            v-if='!isPessoaFisica && viewAtual === "5"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.relacionamentos',
                            icone-titulo-tabela='mdi mdi-account-group-outline'
                        )
                        TabelaSancoesRestricoesPj(
                            v-if='!isPessoaFisica && viewAtual === "6"',
                            :dados='resultadoConsulta || {}',
                            :titulo-tabela='stringsAdaptadas.sancoesRestricoes',
                            icone-titulo-tabela='mdi mdi-file-document-outline'
                        )
    BaseModalExportarArquivo(
        v-if='modalExportarArquivo',
        :show='modalExportarArquivo',
        :dadosUsuarioModalExportar='dadosUsuarioModalExportar',
        :isPessoaFisica='isPessoaFisica',
        width='400px',
        @closeDialog='modalExportarArquivo = false; modalExportarArquivo = ""',
        @exportar='exportarPdfPreAnaliseCredito'
    )
</template>

<script>
import BaseHeaderPreAnaliseCredito from '@/components/preAnaliseCredito/BaseHeaderPreAnaliseCredito';
import Card from '@/components/Card';
import { Money } from 'v-money';
import TabelaInfosPublicasBndesPf from './TabelaInfosPublicasBndes/TabelaInfosPublicasBndesPf.vue';
import TabelaPatrimonioPf from './TabelaPatrimonio/TabelaPatrimonioPf.vue';
import TabelaDadosFinanceirosPf from './TabelaDadosFinanceiros/TabelaDadosFinanceirosPf.vue';
import TabelaDadosFiscaisTributariosPf from './TabelaDadosFiscaisTributarios/TabelaDadosFiscaisTributariosPf.vue';
import TabelaInfosProfissionaisPf from './TabelaInfosProfissionais/TabelaInfosProfissionaisPf.vue';
import TabelaPepPf from './TabelaPep/TabelaPepPf.vue';
import TabelaRelacionamentosPf from './TabelaRelacionamentos/TabelaRelacionamentosPf.vue';
import TabelaSancoesRestricoesPf from './TabelaSancoesRestricoes/TabelaSancoesRestricoesPf.vue';
import TabelaDadosFinanceirosPj from './TabelaDadosFinanceiros/TabelaDadosFinanceirosPj.vue';
import TabelaRelacionamentosPj from './TabelaRelacionamentos/TabelaRelacionamentosPj.vue';
import TabelaDadosFiscaisPj from './TabelaDadosFiscaisTributarios/TabelaDadosFiscaisPj.vue';
import TabelaPatrimonioPj from './TabelaPatrimonio/TabelaPatrimonioPj.vue';
import TabelaInfosPublicasBndesPj from './TabelaInfosPublicasBndes/TabelaInfosPublicasBndesPj.vue';
import TabelaSancoesRestricoesPj from './TabelaSancoesRestricoes/TabelaSancoesRestricoesPj.vue';
import TabelaProcessosJudiciaisPj from './TabelaProcessosJudiciais/TabelaProcessosJudiciaisPj.vue';
import TabelaProcessosJudiciaisPf from './TabelaProcessosJudiciais/TabelaProcessosJudiciaisPf.vue';
import ProcessosJudiciaisTotalizadores from './TabelaProcessosJudiciais/ProcessosJudiciaisTotalizadores.vue';
import BaseModalExportarArquivo from '@/components/preAnaliseCredito/BaseModalExportarArquivo';

import formatters from '@/utils/formatters';

import PreAnaliseService from '@/services/PreAnaliseCredito';

import preAnaliseServiceMixin from '@/mixins/PreAnaliseCreditoMixin';

import store from '@/store';
import { mapActions, mapState } from 'vuex';

function fadeAnimation(element) {
    var style = element.style;
    style.opacity = 1;
    function fade() {
        if ((style.opacity -= 0.1) < 0) {
            style.display = 'none';
        } else {
            setTimeout(fade, 40);
        }
    }
    fade();
}

export default {
    name: 'VisualizarPreAnaliseCredito',

    components: {
        BaseHeaderPreAnaliseCredito,
        Card,
        Money,
        TabelaDadosFinanceirosPf,
        TabelaDadosFiscaisTributariosPf,
        TabelaInfosPublicasBndesPf,
        TabelaPatrimonioPf,
        TabelaInfosProfissionaisPf,
        TabelaPepPf,
        TabelaRelacionamentosPf,
        TabelaSancoesRestricoesPf,
        TabelaProcessosJudiciaisPf,
        TabelaDadosFinanceirosPj,
        TabelaPatrimonioPj,
        TabelaRelacionamentosPj,
        TabelaDadosFiscaisPj,
        TabelaInfosPublicasBndesPj,
        TabelaSancoesRestricoesPj,
        TabelaProcessosJudiciaisPj,
        ProcessosJudiciaisTotalizadores,
        BaseModalExportarArquivo
    },

    mixins: [preAnaliseServiceMixin],

    data() {
        return {
            paramCpfCnpj: this.$route.params.cpfCnpj,
            resultadoConsultaFake: [],
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 9
            },
            resultadoConsulta: {},
            isLoading: false,
            viewAtual: '0',
            isCollapse: false,
            isPessoaFisica: false,
            modalExportarArquivo: false,
            dadosUsuarioModalExportar: {},
            totalPages: 0,
            i18nStrings: {
                titulo: '',
                dadosFinanceiros: 'dadosFinanceiros',
                dadosFiscaisTributarios: 'dadosFiscaisTributarios',
                infoProfissional: 'infoProfissional',
                infoPublicaBNDES: 'infoPublicaBNDES',
                patrimonio: 'patrimonio',
                pessoaPoliticamenteExposta: 'pessoaPoliticamenteExposta',
                processosJudiciais: 'processosJudiciais',
                relacionamentos: 'relacionamentos',
                sancoesRestricoes: 'sancoesRestricoes',
                dadosFiscais: 'dadosFiscais'
            },
            stringsAdaptadas: {}
        };
    },

    computed: {
        ...mapState({
            goBackHomeDashboard: state => state.responsePreAnalisePF ? state.responsePreAnalisePF.goBackHomeDashboard : false
        }),
        itemsMenuPF() {
            return this.mxItemsMenuPF(this.resultadoConsulta) || [];
        },
        itemsMenuPJ() {
            return this.mxItemsMenuPJ(this.resultadoConsulta) || [];
        }
    },

    async created() {
        this.i18nStrings.titulo = this.$t(`mensagens.preAnaliseCredito.visualizar.header.titulo`);
        for (const key in this.i18nStrings) {
            this.stringsAdaptadas[key] = this.$t(`mensagens.preAnaliseCredito.visualizar.tabelas.${this.i18nStrings[key]}`);
        }

        if (this.$route.params.cpfCnpj.length === 11) {
            this.isPessoaFisica = true;
            this.paramCpfCnpj = this.$route.params.cpfCnpj;
        } else if (this.$route.params.cpfCnpj.length === 14) {
            this.isPessoaFisica = false;
            this.paramCpfCnpj = this.$route.params.cpfCnpj;
        } else {
            this.$router.push({
                name: 'PreAnaliseCredito'
            });
        }
        await this.carregarConsulta();
    },
    watch: {
        'paginacao.paginaAtual': 'carregarProcessosJudiciais',
        'paginacao.tamanhoPagina': 'carregarProcessosJudiciais'
    },
    methods: {
        ...mapActions(['setMarcarExportarNeoway_PDF']),

        async carregarConsulta() {
            if (this.paramCpfCnpj) {
                this.isLoading = true;
                const consulaNeowayLocalStorage =
                    JSON.parse(window.localStorage.getItem('consultaNeoway')) ||
                    {};

                if (store.state.responsePreAnalisePF) {
                    this.resultadoConsulta = store.state.responsePreAnalisePF;
                } else if (
                    !store.state.responsePreAnalisePF &&
                    Object.keys(consulaNeowayLocalStorage).length > 0
                ) {
                    this.resultadoConsulta = consulaNeowayLocalStorage;
                } else {
                    this.$router.push({
                        name: 'PreAnaliseCredito'
                    });
                }
            }
        },

        async handlePageChange(pageNumber) {
            this.carregarProcessosJudiciais(pageNumber);
        },

        numeralStringFormatToDocumento(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        mudarViewAtual(event) {
            this.viewAtual = event;
        },

        changeCollapse() {
            let isActive = document.querySelector(
                '#visualizar-pre-analise-credito .el-menu-item.is-active'
            );
            if (this.isCollapse) {
                this.isCollapse = false;
            } else {
                let allMenuItems = document.querySelectorAll(
                    '#visualizar-pre-analise-credito .el-menu .el-menu-item span'
                );
                isActive.style.width = '55px';
                allMenuItems.forEach(element => {
                    fadeAnimation(element);
                });
                setTimeout(() => {
                    this.isCollapse = true;
                }, 380);
            }
        },

        abrirModalExportarDados() {
            this.dadosUsuarioModalExportar.cpfCnpj = this.$route.params.cpfCnpj;

            if (
                this.resultadoConsulta.bndes &&
                this.resultadoConsulta.bndes.facets.nome
            ) {
                this.dadosUsuarioModalExportar.nome =
                    this.mxNormalisarNomes(
                        this.resultadoConsulta.bndes.facets.nome.buckets[0].val
                    ) ||
                    this.mxNormalisarNomes(
                        this.resultadoConsulta.bndes.response.docs[0].cliente
                    );
            } else {
                this.dadosUsuarioModalExportar.nome = this.$t(`mensagens.preAnaliseCredito.erro.nomeNaoEncontrado`);
            }
            this.modalExportarArquivo = true;
        },

        async exportarPdfPreAnaliseCredito(opcoesExportacao_) {
            this.modalExportarArquivo = false;

            const cpfCnpj = this.$route.params.cpfCnpj;
            const idConsulta = this.$route.params.id;
            try {
                await PreAnaliseService.exportarPdfNeoway(
                    opcoesExportacao_,
                    cpfCnpj,
                    idConsulta

                );

                this.$notify.success({
                    message: this.$t(`mensagens.preAnaliseCredito.analiseExportadaComSucesso`)
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(`mensagens.preAnaliseCredito.erro.exportarAnalise`)
                });
            }
        },

        marcarExportacaoAnaliseCreditoPdf() {
            let nome = this.$t(`mensagens.preAnaliseCredito.erro.nomeNaoEncontrado`);

            if (this.resultadoConsulta.bndes) {
                if (this.resultadoConsulta.bndes.facets.nome) {
                    nome =
                        this.resultadoConsulta.bndes.facets.nome.buckets[0].val;
                } else {
                    if (this.resultadoConsulta.bndes.response.docs.length > 0) {
                        nome =
                            this.resultadoConsulta.bndes.response.docs[0]
                                .cliente;
                    } else {
                        nome = this.$t(`mensagens.preAnaliseCredito.erro.nomeNaoEncontrado`);
                    }
                }
            }

            const params = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                tipoDocumento: 'CPF_CNPJ',
                idConsulta: this.$route.params.id,
                numeroCpfCnpj: this.$route.params.cpfCnpj,
                documento:
                    'CPF/CNPJ: ' +
                    this.numeralStringFormatToDocumento(
                        this.$route.params.cpfCnpj
                    ),
                nome: `${this.$t('mensagens.preAnaliseCredito.nome')}: ` + nome
            };

            this.setMarcarExportarNeoway_PDF(params);
        },

        showWarningMessage(resultadoConsulta) {
            var showMessage = false;

            if (!resultadoConsulta?.bndes?.response?.docs.length > 0) {
                showMessage = true;
            } else if (
                !resultadoConsulta.faturamentoEstimado &&
                !resultadoConsulta.faturamentoEstimado &&
                !resultadoConsulta.mteCnd &&
                !resultadoConsulta.empresaPgfnDau &&
                !resultadoConsulta.cvmParticipantes &&
                !resultadoConsulta.historicoFuncional &&
                !resultadoConsulta.participacaoSocietariaUnico &&
                !resultadoConsulta.sintegraRural &&
                !resultadoConsulta.transparencia &&
                !resultadoConsulta.aeronavesOperadores &&
                !resultadoConsulta.aeronavesProprietarios &&
                !resultadoConsulta?.cafir?.areaTotal &&
                !resultadoConsulta.imoveis &&
                !resultadoConsulta.veiculosPesados &&
                !resultadoConsulta.relacionamentos &&
                !resultadoConsulta.cnep &&
                !resultadoConsulta.cnjCnia &&
                !resultadoConsulta.empresaBcbAcordaos &&
                !resultadoConsulta.empresaCeis &&
                !resultadoConsulta.bancoCentral &&
                !resultadoConsulta.mandadoPrisao &&
                !resultadoConsulta.mteTrabalhoEscravo &&
                this.isProcessoJudicialTotalizadoresEmpty(resultadoConsulta.processoJudicialTotalizadores) &&
                !resultadoConsulta.punicao &&
                !resultadoConsulta.pessoaPoliticamenteExposta &&
                !resultadoConsulta.historicoCriminal
            ) {
                showMessage = true;
            }

            return showMessage;
        },

        getTitleWarningMessage(resultadoConsulta) {
            var message = '';

            if (!resultadoConsulta?.bndes?.response?.docs.length > 0) {
                message = this.$t('mensagens.preAnaliseCredito.erro.naoExistemOperacoesContratadas');
            } else if (
                !resultadoConsulta.faturamentoEstimado &&
                !resultadoConsulta.faturamentoEstimado &&
                !resultadoConsulta.mteCnd &&
                !resultadoConsulta.empresaPgfnDau &&
                !resultadoConsulta.cvmParticipantes &&
                !resultadoConsulta.historicoFuncional &&
                !resultadoConsulta.participacaoSocietariaUnico &&
                !resultadoConsulta.sintegraRural &&
                !resultadoConsulta.transparencia &&
                !resultadoConsulta.aeronavesOperadores &&
                !resultadoConsulta.aeronavesProprietarios &&
                !resultadoConsulta?.cafir?.areaTotal &&
                !resultadoConsulta.imoveis &&
                !resultadoConsulta.veiculosPesados &&
                !resultadoConsulta.relacionamentos &&
                !resultadoConsulta.cnep &&
                !resultadoConsulta.cnjCnia &&
                !resultadoConsulta.empresaBcbAcordaos &&
                !resultadoConsulta.empresaCeis &&
                !resultadoConsulta.bancoCentral &&
                !resultadoConsulta.mandadoPrisao &&
                !resultadoConsulta.mteTrabalhoEscravo &&
                this.isProcessoJudicialTotalizadoresEmpty(resultadoConsulta.processoJudicialTotalizadores) &&
                !resultadoConsulta.punicao &&
                !resultadoConsulta.pessoaPoliticamenteExposta &&
                !resultadoConsulta.historicoCriminal
            ) {
                message = this.$t('mensagens.preAnaliseCredito.erro.naoFoiPossivelExibirConsultaBndes');
            }

            return message;
        }
    }
};
</script>

<style lang="scss">
#visualizar-pre-analise-credito {
    font-family: 'Roboto', 'sans serif' !important;

    .visualizar-pre-analise-credito__header__acao__botao {
        color: var(--white);
        border-color: var(--primary);
        border-radius: $default-border-radius;
        font-weight: map-get($font-weight, normal);
        padding: 12px 20px;
        font-size: 14px;
    }

    .visualizar-pre-analise-credito__card {
        .grid-display-pre-analise-credito-collapse {
            display: grid;
            grid-template-columns: 88px 95.2%;
            grid-template-rows: 1fr;
            grid-column-gap: 13px;
            grid-row-gap: 0px;
            width: 99%;
            height: calc(100vh - 312px);
            transition: 0.6s;

            @media only screen and (max-width: 1440px) {
                grid-template-columns: 88px 93.2%;
            }

            @media only screen and (min-width: 1441px) and (max-width: 1520px) {
                grid-template-columns: 88px 93.6%;
            }

            @media only screen and (min-width: 1521px) and (max-width: 1800px) {
                grid-template-columns: 88px 94.8%;
            }
        }

        .grid-display-pre-analise-credito-not-collapse {
            display: grid;
            grid-template-columns: 25% 74.2%;
            grid-template-rows: 1fr;
            grid-column-gap: 13px;
            grid-row-gap: 0px;
            height: calc(100vh - 180px);
            transition: 0.6s;

            @media only screen and (max-width: 1366px) {
                height: calc(100vh - 28vh);
            }

            @media only screen and (min-width: 1367px) and (max-width: 1440px) {
                grid-template-columns: 27% 71.9%;
                height: calc(100vh - 28vh);
            }

            @media only screen and (min-width: 1441px) and (max-width: 1520px) {
                height: calc(100vh - 28vh);
            }

            @media only screen and (min-width: 1521px) and (max-width: 1800px) {
                height: calc(100vh - 28vh);
            }

            @media only screen and (min-width: 1801px) and (max-width: 1920px) {
                height: calc(100vh - 30vh);
            }
        }

        .grid-bloco1 {
            grid-area: 1 / 1 / 2 / 2;
            position: relative;
            min-height: 72vh;
            max-height: 72vh;
        }

        .grid-bloco2 {
            grid-area: 1 / 2 / 2 / 3;
            min-height: 72vh;
            max-height: 72vh;
        }

        .card-container {
            height: 100%;
            border-radius: 5px;
            background-color: var(--white);
            border: solid 1px var(--default-border-color);
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
            padding: 10px 12px;
            overflow-y: auto;
            overflow-x: hidden;

            .el-menu {
                width: 100%;
                border-right: none;
                display: flex;
                flex-direction: column;

                .el-menu-item {
                    padding: 0;
                    border-radius: 5px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    transition: none !important;
                    padding-left: 18px;

                    i {
                        color: #3b3b3b;
                        transition: all 0.3s ease-in-out;
                    }

                    i.mdi {
                        margin-right: 11px;
                        text-align: center;
                        font-size: 24px;
                        vertical-align: middle;
                    }

                    i.mdi.mdi-check-circle-outline.text-success {
                        margin-right: 20px;
                    }

                    i.mdi.mdi-alert-outline.text-warning {
                        margin-right: 20px;
                    }

                    span {
                        width: 100%;
                        color: #3b3b3b;
                        font-weight: 400;
                        font-size: 14px;
                        transition: color 0.3s ease-in-out;
                        display: flex;
                        justify-content: space-between;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        width: 100%;
                    }

                    .el-tooltip {
                        padding: 0px 18px;
                    }
                }

                .el-menu-item.is-active {
                    color: var(--primary);
                    background-color: #b5dc6966;

                    i {
                        color: var(--primary);
                    }

                    span {
                        color: var(--primary);
                        font-weight: 500;
                    }
                }
            }

            .el-menu:not(.el-menu--collapse) {
                width: 100%;

                &::before {
                    content: '';
                    position: absolute;
                    width: 32px;
                    height: 15px;
                    top: -5px;
                    right: -32px;
                    border-radius: 32px 10px 40px 10px;
                    -webkit-box-shadow: -20px -20px 0 var(--primary);
                    box-shadow: -14px -3px 0 var(--primary);
                    z-index: -1;
                }
            }
        }

        .col-3 {
            .card-container {
                padding: 10px 12px;
            }
        }

        .col-9 {
            .card-container {
                padding: 10px 20px;
            }
        }

        .col-1 {
            .card-container {
                padding: 10px 12px;
            }
        }

        .col-11 {
            .card-container {
                padding: 10px 20px;
            }
        }
    }

    .visualizar-pre-analise-credito__card__status {
        line-height: 16.4px;
        color: #3b3b3b;

        .font-bold {
            font-weight: 600;
        }

        .grid-cnpj {
            display: grid;
            grid-template-columns: 1.9fr 1.7fr 1.9fr 2.0fr 1fr;
            grid-template-rows: 1fr;
            grid-column-gap: 20px;
            grid-row-gap: 0px;
            justify-items: stretch;
            align-items: center;
            height: 36px;
        }
        .grid-cpf {
            display: grid;
            grid-template-columns: 1.7fr 1.7fr 2fr 2.2fr 1.7fr 1fr;;
            grid-template-rows: 1fr;
            grid-column-gap: 20px;
            grid-row-gap: 0px;
            justify-items: stretch;
            align-items: center;
            height: 36px;
        }
    }

    .ferramentas-opcoes--bloco--item {
        color: var(--primary);
        font-weight: 500;
        font-size: 15px;
        line-height: 16px;
        transition: color 0.3s ease-in-out;
        cursor: pointer;

        i {
            margin-right: 5px;
        }
    }

    .ferramentas-opcoes--bloco--item:hover {
        color: var(--secondary) !important;
    }

    .el-alert--warning.is-light .el-alert__title {
        color: #d58f08;
    }

    .el-alert--warning.is-light .el-alert__icon {
        color: #d58f08;
    }
}

.arrow-menu-button {
    position: absolute;
    top: 50%;
    height: 22px;
    width: 22px;
    padding: 0 0.3rem;
    background-color: #fff;
    border-radius: 12px;
    cursor: pointer;
    box-shadow: 0 3px 10px -3px rgba(70, 46, 118, 0.3);
    right: -1.4rem;
    transform: translateY(-50%) translateX(-8px);
    transition: 0.3s;
    z-index: 50;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.5);
}

.arrow-menu-button i {
    line-height: 22px;
    transition: 0.3s;
    color: #2c2c2c;
    font-weight: 700;
}

.arrow-menu-button:hover {
    background-color: #dadada;
}

.warning-bndes {
    background-color: #FEF7DE !important;
}</style>
